import React, { Component } from 'react';
import NavigationTabs from '../nav/NavigationTabs'
import { COLORS } from '../../styles/colors';
import { PROGRAM_LIBRARY_MESSAGE } from '../../static-content';
import LibraryList from '../LibraryList';
/**
 * List
 */
export class List extends Component { // eslint-disable-line react/prefer-stateless-function
  state = {
    dataLoaded: false
  }

  componentDidMount() {
    this.props.resetPrograms();
    this.fetchprograms();
  }

  fetchprograms() {
    this.props.fetchListData({
      creatorId: this.props.user._id || localStorage.id,
      limit: 10,
      skip: 0
    }).then(() => {
      this.setState({
        ...this.state,
        dataLoaded: true
      })
    });
  }
  fetchList() {
    this.setState({
      dataLoaded: false
    });
    this.fetchprograms();
  }

  reorder = (items, reqOrders) => {
    this.props.updateOrder(reqOrders, items)
  };

  render() {
    const { programs, cats, user, fetchMorePrograms, resetPrograms, isLoadMoreListing } = this.props;
    return (
      <div>
        <NavigationTabs
          title="Library"
          subtitle="Programs"
          description={PROGRAM_LIBRARY_MESSAGE}
          set="library"
          activeRoute="/library/programs" />
        {this.state.dataLoaded &&
          <div style={{ marginTop: 10, border: '1px solid ' + COLORS.grey }}>
            <LibraryList
              items={Object.values(programs)}
              categories={cats}
              categoryField="categoryId"
              itemType="program"
              user={user}
              fetchprograms={() => this.fetchList()}
              fetchMoreListing = {fetchMorePrograms}
              isLoadMoreListing = {isLoadMoreListing}
              resetListing = { resetPrograms }
              reorder={this.reorder}
            />
          </div>
        }
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/programs/List.js